import { useState } from "react";
import { Tag, Typography } from "antd";

import { IOrdenacaoFonteItem, IUpdateFonteFavorita } from "../../interfaces";

import { EmitirErro } from "../../../../../../../../services/EmitirErro";
import FonteActions, { IFonteActionsProps } from "../FonteActions";

interface IProps {
    item: IOrdenacaoFonteItem;
    solicitacaoId: number;
    onChangeFavorita?: (item: IOrdenacaoFonteItem, favoritaValue: boolean,) => void;
    fonteActionsProps: Omit<IFonteActionsProps, "item" | "onToggleFavorite" | "favorita" | "solicitacaoId">;
    selectedCategoriaId: number | null;
    onUpdateFonteFavorita?: (data: IUpdateFonteFavorita) => Promise<void>;
}

export default function OrdenacaoFonteItem({
    item,
    solicitacaoId,
    onChangeFavorita,
    fonteActionsProps,
    selectedCategoriaId,
    onUpdateFonteFavorita,
}: IProps) {
    const [favorita, setFavorita] = useState(item.favorita);

    const handleToggleFavorite = async () => {
        try {
            const favoritaValue = !favorita;

            if (onUpdateFonteFavorita) {
                await onUpdateFonteFavorita({
                    favorita: favoritaValue,
                    numeroFonte: item.numero,
                    solicitacaoId,
                });
            }

            setFavorita(favoritaValue);
            onChangeFavorita?.(
                {
                    ...item,
                    favorita: favoritaValue,
                },
                favoritaValue,
            )
        } catch (error) {
            EmitirErro(error);
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                justifyContent: 'space-between',
                padding: '6px 16px'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography.Text>{item.descricao}</Typography.Text>
                <Typography.Text type="secondary">{item.numero}</Typography.Text>

                {
                    selectedCategoriaId === null && item.categoria && (
                        <Tag
                            color="processing"
                            style={{ maxWidth: 'fit-content' }}
                        >
                            {item.categoria}
                        </Tag>
                    )
                }
            </div>

            <FonteActions
                {...fonteActionsProps}
                favorita={favorita}
                item={item}
                onToggleFavorite={handleToggleFavorite}
                solicitacaoId={solicitacaoId}
            />
        </div>
    )
}
